import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

const colorMap: Record<string, string> = {
  primary: "text-primary-600 bg-primary-100",
  accent: "text-accent-700 bg-accent-100",
  secondary: "text-secondary-700 bg-secondary-100",
  foreground: "text-foreground-700 bg-foreground-100",
};

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-medium text-primary-600">CATEGORIES</p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">按题材选书</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              恋爱、奇幻、悬疑……找到你偏爱的题材，快速筛选感兴趣的作品。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="card-lift group relative overflow-hidden rounded-lg bg-background-50 aspect-[4/5]"
            >
              <img
                src={c.image}
                alt={`${c.name} 韩漫分类`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4 text-background-50">
                <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${colorMap[c.color]}`}>
                  {c.en}
                </span>
                <h3 className="mt-2 font-heading text-xl">{c.name}</h3>
                <p className="mt-1 text-xs text-background-100">{c.count}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}